import AdminKeyService from './AdminKeyService';

class AuthorizationService {
    // Check if user can edit election title
    canEditElectionTitle(electionId, election) {
        // If election is not protected, anyone can edit
        if (!election.isProtected) {
            return true;
        }
        
        // If election is protected, only users with election admin key can edit
        return AdminKeyService.hasElectionAdminKey(electionId);
    }

    // Check if user can modify election options (add, edit, delete)
    canModifyElectionOptions(electionId, election) {
        // If election is not protected, anyone can modify options
        if (!election.isProtected) {
            return true;
        }
        
        // If election is protected but allows non-admin option modifications, anyone can modify
        if (!election.adminOnlyOptionModifications) {
            return true;
        }
        
        // If election is protected and requires admin for options, check admin key
        return AdminKeyService.hasElectionAdminKey(electionId);
    }

    // Check if user can delete a vote
    canDeleteVote(electionId, voteId, election) {
        // If election is not protected, anyone can delete votes
        if (!election.isProtected) {
            return true;
        }
        
        // If election is protected, check if user has vote admin key
        if (AdminKeyService.hasVoteAdminKey(voteId)) {
            return true;
        }
        
        // If election is protected, check if user has election admin key
        return AdminKeyService.hasElectionAdminKey(electionId);
    }

    // Check if user can edit a vote (same permissions as delete)
    canEditVote(electionId, voteId, election) {
        return this.canDeleteVote(electionId, voteId, election);
    }

    // Check if user can delete the election
    canDeleteElection(electionId, election) {
        // If election is not protected, anyone can delete
        if (!election.isProtected) {
            return true;
        }

        // If election is protected, only users with election admin key can delete
        return AdminKeyService.hasElectionAdminKey(electionId);
    }
}

const authorizationService = new AuthorizationService();
export default authorizationService;